// Centralized user-facing text constants

export const ERROR_TEXT = {
  GENERIC_TITLE: 'Something went wrong',
  GENERIC_SUBTITLE: "We're sorry, but something unexpected happened. Please try again.",
  RELOAD: 'Reload Page',
  GO_HOME: 'Go Home',
  RETRY: 'Retry',
};

export const CARD_TEXT = {
  NO_DATA: 'No data',
  NO_DATA_ALT: 'No Data',
  NO_BID: 'No Bid',
  NO_BIDS: 'No bids',
  // Only auctions settled in the last 90 days count — older ones are pruned, so a player
  // with no auction in that window shows no last-auction price (see the API's
  // getRecentAuctionCardForPlayer 90-day window).
  LAST_AUCTION_PRICE: 'The last auction price (within the last 90 days)',
  LISTED_PRICE: 'Listed price',
  MARKET_FLOOR: 'The lowest market price (floor)',
  LAST_BID: 'Last bid',
};

export const CARD_BONUS_TEXT = {
  RARITY: 'Rarity Bonus:',
  SEASON: 'Season Bonus:',
  XP: 'XP Bonus:',
  COLLECTION: 'Collection Bonus:',
  NO_BONUS: 'No Bonus',
};

export const PLAYER_TEXT = {
  NO_CLUB: 'No club data',
  NO_LEAGUE: 'No league data',
  YEARS: 'years',
};

export const SCORES_TEXT = {
  NO_DATA_AVAILABLE: 'No data available',
  GAME_WEEK: 'Game Week',
  MATCH_DATE: 'Match Date',
  GAME_STATUS: 'Game Status',
  GAME: 'Game',
  GAME_TYPE: 'Game Type',
  CLUB: 'Club',
  NATIONAL_TEAM: 'National Team',
  MINUTES_PLAYED: 'Minutes Played',
  DECISIVE_ACTIONS: 'Decisive Actions',
  DECISIVE_SCORE: 'Decisive Score',
  ALL_AROUND_SCORE: 'All Around Score',
  SCORE_VALUE: 'Score Value',
  DNP: 'DNP',
  SHOW_BREAKDOWN: 'Show score breakdown',
  BREAKDOWN_POSITIVE_DECISIVE: 'Positive decisive',
  BREAKDOWN_NEGATIVE_DECISIVE: 'Negative decisive',
  BREAKDOWN_NO_DATA: 'No detailed breakdown available for this game.',
  TOOLTIP_STARTED: 'Started',
  TOOLTIP_SUBSTITUTED_IN: 'Substituted in',
  TOOLTIP_ON_BENCH: 'On the Bench',
  TOOLTIP_NOT_IN_SQUAD: 'Not in the Squad',
  FILTER_ALL_GAMES: 'All Games',
  FILTER_ALL_TEAMS: 'All Teams',
  STATUS_STARTED: 'Started',
  STATUS_SUBSTITUTED_IN: 'Substituted in',
  STATUS_NOT_PLAYED: 'Not played',
  TOOLTIP_YELLOW_CARD: 'Yellow card',
  TOOLTIP_RED_CARD: 'Red card',
  TOOLTIP_PENALTY_CONCEDED: 'Penalty conceded',
  TOOLTIP_ERROR_LEAD_TO_GOAL: 'Error lead to goal',
  TOOLTIP_OWN_GOAL: 'Own goal',
  TOOLTIP_GOAL: 'Goal',
  TOOLTIP_ASSIST: 'Assist',
  TOOLTIP_PENALTY_WON: 'Penalty won',
};

// Tab labels for the player profile views (football + NBA).
export const PLAYER_TAB_LABELS = {
  PLAYED_GAMES: 'Played Games',
  NEXT_GAMES: 'Next Games',
  LISTED_CARDS: 'Cheapest Listed Cards',
  AUCTIONS: 'Recent Auctions',
  REWARDS: 'Rewards',
  INSTANT_BUYS: 'Recent Instant Buys',
};

// Empty-state copy for the card tabs (shown when a tab has no cards).
export const PLAYER_TAB_EMPTY_TEXT = {
  LISTED_CARDS: 'No listed cards',
  AUCTIONS: 'No auctions',
  REWARDS: 'No rewards',
  INSTANT_BUYS: 'No instant buys',
};

export const NEXT_GAMES_TEXT = {
  NO_UPCOMING_GAMES: 'No upcoming games',
  GAME_WEEK: 'Game Week',
  MATCH_DATE: 'Match Date',
  COMPETITION: 'Competition',
  GAME: 'Game',
  GAME_TYPE: 'Game Type',
  HOME_AWAY: 'Home / Away',
  HOME: 'Home',
  AWAY: 'Away',
};

export const MENU_TEXT = {
  MENU: 'Menu',
  DASHBOARD: 'Dashboard',
  AUCTIONS: 'Auctions',
  MARKET: 'Market',
  INSTANT_BUY: 'Instant Buy',
  ALL_CARDS: 'All Cards',
  TOP_PLAYERS: 'Top Players',
  FOOTBALL: 'Football',
  NBA: 'NBA',
};

export const AUTH_TEXT = {
  CONNECT: 'Connect to Sorare',
  CONNECTING: 'Connecting…',
  MY_CARDS: 'My Cards',
  REFRESH_MY_CARDS: 'Refresh my cards',
  DISCONNECT: 'Disconnect',
  CONNECT_FAILED_TITLE: 'Could not connect',
  CONNECT_FAILED: 'Something went wrong connecting your Sorare account. Please try again.',
  CONNECT_DENIED_TITLE: 'Connection cancelled',
  CONNECT_DENIED: 'You declined the Sorare authorisation request.',
};

export const CARD_REFRESH_TEXT = {
  REQUEST_UPDATE: 'Request to update card in DB',
};

export const LEAGUE_SELECT_TEXT = {
  SELECT_LEAGUE: 'Select a league',
  ALL_LEAGUES: 'All Leagues',
};
